import { LitElement, html, css, PropertyValues } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { addGlobalStylesToShadowRoot } from "../../util/globalStyleSheetsUtil";
import { randstr } from "../../util/stringUtils";

@customElement("ehm-audioplayer")
export class EhmAudioplayer extends LitElement {
  static styles = css`
    :host {
    --icon-size: 2rem;
    --icon-color: unset;
	.main-player-iframe {
		display: none;
	}

  .marquee {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
}
.marquee {
span {
    display: inline-block;   
}
&.short{
span{
    animation: marquee 7s linear infinite;
}
    }
    &.medium{
    span{
    animation: marquee 13s linear infinite;
}
    }
    &.long{
    span{
    animation: marquee 20s linear infinite;
}
    }
    }


  @media screen and (-webkit-min-device-pixel-ratio:0) {
    input[type='range'] {
      width: 100%;
      -webkit-appearance: none;
      background-color: #9a905d;
      height: 4px;
    }

    .backdrop {
      position: fixed;
      top: var(--menu-offset, 6rem);
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(3px);
      z-index: 999;
      transition: opacity 300ms ease-in-out;
    }

    .shareoptions{
    h3{
    color: #212121;
    font-size: 1.25rem !important;
    }
    border: 1px solid var(--border-grey);
    box-shadow: 0 1px 3px 0 rgba(10, 13, 18, 0.10), 0 1px 2px -1px rgba(10, 13, 18, 0.10);
    padding: 2rem;
    position: fixed;
    bottom: 7rem;
    right: 7rem;
    background-color: white;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    gap: 1.5rem;
    z-index: 1000;
    @media (max-width: 768px) {
            right: 50%;
            transform: translateX(50%);
                            width: 80%;
            padding-bottom: 2rem;
                            box-sizing: border-box;
                width: 97vw;
		}
.close-button{
--icon-size: 14px;
--icon-color: #232948
}
    .copy-button{
    border: 1px solid var(--border-brand);
    font-weight: 400;
    color: var(--text-primary);
    line-height: 1.5;
    }

    .shareoptions-morebuttons{
    a{
     display: flex;
    font-size: 0.75rem !important;
    flex-direction: column;
    align-items: center;
    gap: 0.375rem;
    color: black;
    text-decoration: none;
    }
    .download-button{
    >div{
    width: 2.5rem;
      height: 2.5rem;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none'%3E%3Crect width='39' height='39' x='.5' y='.5' fill='%23fff' rx='19.5'/%3E%3Crect width='39' height='39' x='.5' y='.5' stroke='%23d5d7da' rx='19.5'/%3E%3Cpath fill='%23232948' d='M29 21.5v6a.75.75 0 0 1-.75.75h-16.5a.75.75 0 0 1-.75-.75v-6a.75.75 0 1 1 1.5 0v5.25h15V21.5a.75.75 0 1 1 1.5 0m-9.53.53a.747.747 0 0 0 1.06 0l3.75-3.75a.75.75 0 1 0-1.06-1.06l-2.47 2.47V11a.75.75 0 1 0-1.5 0v8.69l-2.47-2.47a.75.75 0 1 0-1.06 1.06z'/%3E%3C/svg%3E");
}
    }
    .pdf-button{
    >div{
    width: 2.5rem;
      height: 2.5rem;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none'%3E%3Crect width='39' height='39' x='.5' y='.5' fill='%23fff' rx='19.5'/%3E%3Crect width='39' height='39' x='.5' y='.5' stroke='%23d5d7da' rx='19.5'/%3E%3Cpath fill='%23232948' d='M29 22.25a.75.75 0 0 1-.75.75H26v1.5h1.5a.75.75 0 1 1 0 1.5H26v1.5a.75.75 0 1 1-1.5 0v-5.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75m-12.375 1.875A2.625 2.625 0 0 1 14 26.75h-.75v.75a.75.75 0 1 1-1.5 0v-5.25a.75.75 0 0 1 .75-.75H14a2.625 2.625 0 0 1 2.625 2.625m-1.5 0A1.125 1.125 0 0 0 14 23h-.75v2.25H14a1.125 1.125 0 0 0 1.125-1.125m8.25.75A3.375 3.375 0 0 1 20 28.25h-1.5a.75.75 0 0 1-.75-.75v-5.25a.75.75 0 0 1 .75-.75H20a3.375 3.375 0 0 1 3.375 3.375m-1.5 0A1.875 1.875 0 0 0 20 23h-.75v3.75H20a1.875 1.875 0 0 0 1.875-1.875M11.75 18.5v-6.75a1.5 1.5 0 0 1 1.5-1.5h9a.75.75 0 0 1 .53.22l5.25 5.25a.75.75 0 0 1 .22.53v2.25a.75.75 0 1 1-1.5 0V17h-4.5a.75.75 0 0 1-.75-.75v-4.5h-8.25v6.75a.75.75 0 1 1-1.5 0m11.25-3h2.69L23 12.81z'/%3E%3C/svg%3E");
    }
}
    display: flex;
    align-items: center;
    gap: 1.375rem;
    border-top: 1px solid var(--border-grey);
    padding-top: 1.5rem;
    }

    .shareoptions-header{
    display: flex;
    justify-content: space-between;
    button{
    position: relative;
    bottom: 1rem;
    left: 1rem;
    }
}
    .share-buttons{
    display: flex;
    flex-direction: row;
    gap: 1.25rem;
    a{
    display: flex;
    font-size: 0.75rem;
    flex-direction: column;
    align-items: center;
    height: 4rem;
    gap: 0.375rem;
    color: black;
    text-decoration: none;
    &.twitter-button{
    >div{
    width: 2.5rem;
    height: 2.5rem;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none'%3E%3Crect width='39' height='39' x='.5' y='.5' fill='%23fff' rx='19.5'/%3E%3Crect width='39' height='39' x='.5' y='.5' stroke='%23d5d7da' rx='19.5'/%3E%3Cg clip-path='url(%23a)'%3E%3Cmask id='b' width='14' height='14' x='13' y='13' maskUnits='userSpaceOnUse' style='mask-type:luminance'%3E%3Cpath fill='%23fff' d='M13 13h14v14H13z'/%3E%3C/mask%3E%3Cg mask='url(%23b)'%3E%3Cpath fill='%23000' d='M24.025 13.656h2.147l-4.69 5.374L27 26.344h-4.32l-3.386-4.435-3.87 4.435h-2.149l5.016-5.75L13 13.657h4.43l3.056 4.053zm-.755 11.4h1.19l-7.68-10.179h-1.276z'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M13 13h14v14H13z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
    }
    }
    &.facebook-button{
    >div{
    width: 2.5rem;
    height: 2.5rem;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%232e60ff' d='M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 9.983 7.314 18.257 16.875 19.757V25.781h-5.078V20h5.078v-4.406c0-5.013 2.986-7.781 7.554-7.781 2.189 0 4.477.39 4.477.39v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.123V20h5.547l-.887 5.781h-4.66v13.976C32.686 38.257 40 29.983 40 20'/%3E%3Cpath fill='%23fff' d='M27.785 25.781 28.672 20h-5.547v-3.752c0-1.581.775-3.123 3.26-3.123h2.521V8.203s-2.288-.39-4.477-.39c-4.568 0-7.554 2.768-7.554 7.78V20h-5.078v5.781h5.078v13.976a20.2 20.2 0 0 0 6.25 0V25.781z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h40v40H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");;
    }
    }
    &.email-button{
    >div{
    width: 2.5rem;
    height: 2.5rem;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'%3E%3Crect width='39' height='39' x='.5' y='.5' fill='%23fff' rx='19.5'/%3E%3Crect width='39' height='39' x='.5' y='.5' stroke='%23d5d7da' rx='19.5'/%3E%3Cpath fill='%23232948' d='M29 12.5H11a.75.75 0 0 0-.75.75V26a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V13.25a.75.75 0 0 0-.75-.75M27.072 14 20 20.483 12.928 14zm1.178 12h-16.5V14.955l7.743 7.098a.75.75 0 0 0 1.014 0l7.743-7.098z'/%3E%3C/svg%3E");
    }
    }
    &.email-button{
    >div{
    width: 2.5rem;
    height: 2.5rem;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='39' height='39' rx='19.5' fill='white'/%3E%3Crect x='0.5' y='0.5' width='39' height='39' rx='19.5' stroke='%23D5D7DA'/%3E%3Cpath d='M29 12.5H11C10.8011 12.5 10.6103 12.579 10.4697 12.7197C10.329 12.8603 10.25 13.0511 10.25 13.25V26C10.25 26.3978 10.408 26.7794 10.6893 27.0607C10.9706 27.342 11.3522 27.5 11.75 27.5H28.25C28.6478 27.5 29.0294 27.342 29.3107 27.0607C29.592 26.7794 29.75 26.3978 29.75 26V13.25C29.75 13.0511 29.671 12.8603 29.5303 12.7197C29.3897 12.579 29.1989 12.5 29 12.5ZM27.0716 14L20 20.4828L12.9284 14H27.0716ZM28.25 26H11.75V14.9553L19.4928 22.0531C19.6312 22.1801 19.8122 22.2506 20 22.2506C20.1878 22.2506 20.3688 22.1801 20.5072 22.0531L28.25 14.9553V26Z' fill='%23232948'/%3E%3C/svg%3E%0A");
    }
    }
    &.linkedin-button{
    >div{
    width: 2.5rem;
    height: 2.5rem;
                                background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg width='39' height='39' viewBox='0 0 39 39' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.2 0C8.596 0 0 8.596 0 19.2C0 29.804 8.596 38.4 19.2 38.4C29.804 38.4 38.4 29.804 38.4 19.2C38.4 8.596 29.804 0 19.2 0ZM14.5 27.158H10.612V14.646H14.5V27.158ZM12.532 13.11C11.304 13.11 10.51 12.24 10.51 11.164C10.51 10.066 11.328 9.222 12.582 9.222C13.836 9.222 14.604 10.066 14.628 11.164C14.628 12.24 13.836 13.11 12.532 13.11ZM28.7 27.158H24.812V20.224C24.812 18.61 24.248 17.514 22.842 17.514C21.768 17.514 21.13 18.256 20.848 18.97C20.744 19.224 20.718 19.584 20.718 19.942V27.156H16.828V18.636C16.828 17.074 16.778 15.768 16.726 14.644H20.104L20.282 16.382H20.36C20.872 15.566 22.126 14.362 24.224 14.362C26.782 14.362 28.7 16.076 28.7 19.76V27.158Z' fill='%23303788'/%3E%3C/svg%3E%0A");
    }
    }
    &.embed-button{
    >div{
    width: 2.5rem;
    height: 2.5rem;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='39' height='39' rx='19.5' fill='white'/%3E%3Crect x='0.5' y='0.5' width='39' height='39' rx='19.5' stroke='%23D5D7DA'/%3E%3Cpath d='M16.7474 14.5625L10.6246 20L16.7437 25.4375C16.8176 25.5028 16.8778 25.5821 16.9211 25.6708C16.9643 25.7594 16.9896 25.8558 16.9956 25.9542C17.0016 26.0527 16.9882 26.1513 16.9561 26.2446C16.9239 26.3379 16.8737 26.4239 16.8084 26.4978C16.743 26.5716 16.6637 26.6319 16.5751 26.6751C16.4864 26.7184 16.3901 26.7437 16.2916 26.7497C16.1932 26.7557 16.0945 26.7423 16.0012 26.7101C15.908 26.678 15.8219 26.6278 15.7481 26.5625L8.99806 20.5625C8.91826 20.4921 8.85434 20.4055 8.81056 20.3085C8.76678 20.2115 8.74414 20.1064 8.74414 20C8.74414 19.8935 8.76678 19.7884 8.81056 19.6914C8.85434 19.5944 8.91826 19.5078 8.99806 19.4375L15.7481 13.4375C15.8219 13.3718 15.908 13.3214 16.0014 13.289C16.0947 13.2567 16.1935 13.243 16.2922 13.2489C16.3908 13.2547 16.4873 13.2799 16.5762 13.323C16.6651 13.3662 16.7446 13.4264 16.8102 13.5003C16.8759 13.5741 16.9263 13.6602 16.9587 13.7536C16.991 13.8469 17.0047 13.9457 16.9988 14.0444C16.993 14.143 16.9678 14.2395 16.9247 14.3284C16.8815 14.4173 16.8213 14.4968 16.7474 14.5625ZM30.9974 19.4375L24.2474 13.4375C24.0983 13.3054 23.9027 13.2381 23.7039 13.2502C23.505 13.2623 23.3192 13.353 23.1871 13.5021C23.0551 13.6513 22.9877 13.8468 22.9999 14.0457C23.012 14.2445 23.1026 14.4304 23.2518 14.5625L29.3746 20L23.2556 25.4375C23.1817 25.5028 23.1214 25.5821 23.0782 25.6708C23.035 25.7594 23.0096 25.8558 23.0036 25.9542C22.9976 26.0527 23.0111 26.1513 23.0432 26.2446C23.0753 26.3379 23.1255 26.4239 23.1909 26.4978C23.2562 26.5716 23.3355 26.6319 23.4242 26.6751C23.5129 26.7184 23.6092 26.7437 23.7076 26.7497C23.8061 26.7557 23.9048 26.7423 23.998 26.7101C24.0913 26.678 24.1773 26.6278 24.2512 26.5625L31.0012 20.5625C31.081 20.4921 31.1449 20.4055 31.1887 20.3085C31.2325 20.2115 31.2551 20.1064 31.2551 20C31.2551 19.8935 31.2325 19.7884 31.1887 19.6914C31.1449 19.5944 31.081 19.5078 31.0012 19.4375H30.9974Z' fill='%23232948'/%3E%3C/svg%3E%0A");
    }
    }
    }
    }

    .triangle-down {
                      position: absolute;
                bottom: -1rem;
                right: 0rem;
                width: 0;
                height: 0;
                border-left: 1rem solid transparent;
                border-right: 0rem solid transparent;
                border-top: 2rem solid white;
                @media (max-width: 768px) {
      right: 2.5rem;
		}
      }
    a {
      display: block;
      &:hover{
        background-color: rgba(0,0,0,0.1);}
    }
    }
    
    input[type='range']::-webkit-slider-runnable-track {
      height: 10px;
      -webkit-appearance: none;
      color: #8C93A4;
      margin-top: -1px;
    }
    
    input[type='range']::-webkit-slider-thumb {
      -webkit-appearance: none;
      display: none;
      background: #fff;
      @media (max-width: 768px) {
            display: block;
            height: 10px;
            width: 10px;
		}
    }
}

	.podcast-player {
          box-sizing: border-box;
          z-index: 1000;
		color: white;
		padding: 10px 24px;
		border-radius: 1rem;
		position: fixed;
		bottom: 0.75rem;
		left: 50%;
    transform: translateX(-50%);
		width: calc(100% - 1.5rem);
		min-height: 4rem;
		border: none;
		background: rgba(1, 5, 18, 0.90);
    max-width: 1416px;

    @media (max-width: 768px) {
						padding: 0.75rem;
					}

		.podcast-player-content {
			height: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
      @media (max-width: 768px) {
      flex-direction: column;
		}
.podcast-player-buttons.mobile-hidden{
width: 100%;
max-width: 256px;
justify-content: end;
      --icon-size: 1.5rem;
      }
			.podcast-player-actions {
      max-width: 500px;
      @media (max-width: 768px) {
      max-width: unset;
		}
      
      .podcast-player-actions__content{
      width: 100%;
                          align-self: baseline;
      display:flex;
      justify-content: center;
      @media (max-width: 768px) {
						justify-content: space-between;
					}
      > div{
       width: 33.3%;
       }
      .podcast-player-buttons{
      
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      align-items: center;
      width: auto;
      }
      .podcast-player-moreoptions{
      button{
      float: right;
      }
      }
      }
      
      .play-button-variant {
      padding: 0 !important;
      &:before{
      height: 40px !important;
      width: 40px !important;
      background-image: url("data:image/svg+xml,%3Csvg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3CforeignObject x='-16' y='-16' width='76' height='76'%3E%3Cdiv xmlns='http://www.w3.org/1999/xhtml' style='backdrop-filter:blur(8px);clip-path:url(%23bgblur_0_8231_4549_clip_path);height:100%25;width:100%25'%3E%3C/div%3E%3C/foreignObject%3E%3Cg data-figma-bg-blur-radius='16'%3E%3Cpath d='M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z' fill='white'/%3E%3Cpath d='M30.9375 20.8472C31.8542 21.3596 31.8542 22.6405 30.9375 23.1528L18.5625 30.0697C17.6458 30.582 16.5 29.9416 16.5 28.9169L16.5 15.0831C16.5 14.0584 17.6458 13.418 18.5625 13.9303L30.9375 20.8472Z' fill='%2316171B'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='bgblur_0_8231_4549_clip_path' transform='translate(16 16)'%3E%3Cpath d='M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A") !important;
      
      }
      &.play-button-variant--isplaying{
      &:before{
      background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='40' height='40' rx='20' fill='%23F6F6F6'/%3E%3Cpath d='M28.25 12.5V27.5C28.25 27.8978 28.092 28.2794 27.8107 28.5607C27.5294 28.842 27.1478 29 26.75 29H23C22.6022 29 22.2206 28.842 21.9393 28.5607C21.658 28.2794 21.5 27.8978 21.5 27.5V12.5C21.5 12.1022 21.658 11.7206 21.9393 11.4393C22.2206 11.158 22.6022 11 23 11H26.75C27.1478 11 27.5294 11.158 27.8107 11.4393C28.092 11.7206 28.25 12.1022 28.25 12.5ZM17 11H13.25C12.8522 11 12.4706 11.158 12.1893 11.4393C11.908 11.7206 11.75 12.1022 11.75 12.5V27.5C11.75 27.8978 11.908 28.2794 12.1893 28.5607C12.4706 28.842 12.8522 29 13.25 29H17C17.3978 29 17.7794 28.842 18.0607 28.5607C18.342 28.2794 18.5 27.8978 18.5 27.5V12.5C18.5 12.1022 18.342 11.7206 18.0607 11.4393C17.7794 11.158 17.3978 11 17 11Z' fill='%232B2C2F'/%3E%3C/svg%3E%0A") !important;
    
      }
      }
      }
      .podcast-player-timeline {
        width: 100%;

        &:hover, &:focus-within{
        input[type='range']::-webkit-slider-thumb {
      width: 10px;
      height: 10px;
      display: block;
    }
        }
      }
      width: 100%;
				display: flex;
        flex-direction: column;
				align-items: center;
				gap: 0.5rem;
        > div{
          display: flex;
          gap: 0.5rem;
          flex-direction: row;
          align-items: center;
          }
			}

			.ff-button {
				width: 24px;
				height: 24px;
				background-repeat: no-repeat;
				background-color: transparent;
				border: none;
        cursor: pointer;
				background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.5 5.25V9.75C22.5 9.94891 22.421 10.1397 22.2803 10.2803C22.1397 10.421 21.9489 10.5 21.75 10.5H17.25C17.0511 10.5 16.8603 10.421 16.7197 10.2803C16.579 10.1397 16.5 9.94891 16.5 9.75C16.5 9.55109 16.579 9.36032 16.7197 9.21967C16.8603 9.07902 17.0511 9 17.25 9H19.8188L17.3259 6.71625L17.3025 6.69375C16.2601 5.65171 14.9337 4.93993 13.4891 4.64732C12.0445 4.35472 10.5457 4.49427 9.17991 5.04853C7.81414 5.6028 6.64197 6.5472 5.80982 7.76378C4.97768 8.98035 4.52245 10.4152 4.501 11.8889C4.47956 13.3627 4.89286 14.8102 5.68926 16.0504C6.48566 17.2907 7.62986 18.2688 8.97892 18.8626C10.328 19.4564 11.8221 19.6394 13.2746 19.389C14.7271 19.1385 16.0736 18.4656 17.1459 17.4544C17.2905 17.3176 17.4835 17.2439 17.6825 17.2494C17.8814 17.255 18.07 17.3393 18.2067 17.4839C18.3435 17.6285 18.4172 17.8215 18.4117 18.0204C18.4061 18.2193 18.3218 18.4079 18.1772 18.5447C16.5098 20.126 14.298 21.0052 12 21H11.8763C10.4023 20.9798 8.95579 20.5979 7.66398 19.8877C6.37216 19.1776 5.27455 18.161 4.46762 16.9274C3.6607 15.6937 3.16915 14.2807 3.0362 12.8126C2.90324 11.3445 3.13294 9.86615 3.70511 8.50759C4.27728 7.14902 5.1744 5.9518 6.31762 5.02115C7.46085 4.0905 8.81517 3.45491 10.2616 3.17024C11.7079 2.88558 13.2021 2.96055 14.6127 3.38858C16.0234 3.81661 17.3073 4.58458 18.3516 5.625L21 8.04375V5.25C21 5.05109 21.079 4.86032 21.2197 4.71967C21.3603 4.57902 21.5511 4.5 21.75 4.5C21.9489 4.5 22.1397 4.57902 22.2803 4.71967C22.421 4.86032 22.5 5.05109 22.5 5.25Z' fill='white'/%3E%3Cpath d='M7.926 12.672H9.12V13.098H7.926V14.334H7.494V13.098H6.3V12.672H7.494V11.43H7.926V12.672ZM11.5636 15H11.0476V12.006C11.0476 11.89 11.0476 11.792 11.0476 11.712C11.0516 11.632 11.0556 11.558 11.0596 11.49C11.0636 11.418 11.0676 11.344 11.0716 11.268C11.0076 11.332 10.9496 11.386 10.8976 11.43C10.8456 11.474 10.7796 11.53 10.6996 11.598L10.2436 11.97L9.96759 11.616L11.1256 10.716H11.5636V15ZM14.5172 12.372C14.8092 12.372 15.0632 12.422 15.2792 12.522C15.4952 12.622 15.6612 12.766 15.7772 12.954C15.8972 13.138 15.9572 13.364 15.9572 13.632C15.9572 13.928 15.8932 14.184 15.7652 14.4C15.6372 14.612 15.4532 14.776 15.2132 14.892C14.9772 15.004 14.6912 15.06 14.3552 15.06C14.1352 15.06 13.9272 15.04 13.7312 15C13.5392 14.96 13.3772 14.902 13.2452 14.826V14.328C13.3892 14.416 13.5632 14.486 13.7672 14.538C13.9752 14.586 14.1732 14.61 14.3612 14.61C14.5732 14.61 14.7572 14.578 14.9132 14.514C15.0732 14.446 15.1972 14.344 15.2852 14.208C15.3732 14.068 15.4172 13.894 15.4172 13.686C15.4172 13.406 15.3312 13.192 15.1592 13.044C14.9872 12.892 14.7152 12.816 14.3432 12.816C14.2312 12.816 14.1032 12.826 13.9592 12.846C13.8152 12.866 13.6992 12.886 13.6112 12.906L13.3472 12.738L13.5092 10.716H15.6572V11.196H13.9592L13.8572 12.438C13.9252 12.426 14.0172 12.412 14.1332 12.396C14.2492 12.38 14.3772 12.372 14.5172 12.372Z' fill='white'/%3E%3C/svg%3E%0A");
			}

			.rewind-button {
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21 11.9999C21.0002 14.366 20.0686 16.6371 18.4069 18.3215C16.7451 20.0059 14.4869 20.9681 12.1209 20.9999H12C9.70147 21.0056 7.48901 20.126 5.82187 18.5436C5.75028 18.4759 5.69273 18.3948 5.6525 18.3048C5.61227 18.2149 5.59016 18.1179 5.58741 18.0194C5.58467 17.9209 5.60136 17.8228 5.63652 17.7307C5.67168 17.6387 5.72463 17.5544 5.79234 17.4829C5.86006 17.4113 5.94121 17.3537 6.03116 17.3135C6.12112 17.2733 6.21812 17.2511 6.31662 17.2484C6.41512 17.2457 6.5132 17.2623 6.60525 17.2975C6.69731 17.3327 6.78153 17.3856 6.85312 17.4533C7.92544 18.4646 9.27195 19.1375 10.7245 19.3879C12.177 19.6384 13.6711 19.4553 15.0202 18.8615C16.3692 18.2678 17.5134 17.2897 18.3098 16.0494C19.1062 14.8091 19.5195 13.3617 19.4981 11.8879C19.4766 10.4141 19.0214 8.9793 18.1892 7.76273C17.3571 6.54616 16.1849 5.60175 14.8192 5.04748C13.4534 4.49322 11.9546 4.35367 10.51 4.64628C9.06537 4.93888 7.739 5.65066 6.69656 6.6927C6.6889 6.70099 6.68076 6.70881 6.67219 6.71614L4.18031 8.99989H6.75C6.94891 8.99989 7.13968 9.07891 7.28033 9.21956C7.42098 9.36021 7.5 9.55098 7.5 9.74989C7.5 9.9488 7.42098 10.1396 7.28033 10.2802C7.13968 10.4209 6.94891 10.4999 6.75 10.4999H2.25C2.05109 10.4999 1.86032 10.4209 1.71967 10.2802C1.57902 10.1396 1.5 9.9488 1.5 9.74989V5.24989C1.5 5.05098 1.57902 4.86021 1.71967 4.71956C1.86032 4.57891 2.05109 4.49989 2.25 4.49989C2.44891 4.49989 2.63968 4.57891 2.78033 4.71956C2.92098 4.86021 3 5.05098 3 5.24989V8.04364L5.64844 5.62489C6.90842 4.3698 8.512 3.51614 10.2567 3.17167C12.0015 2.8272 13.8092 3.00736 15.4516 3.68941C17.0941 4.37146 18.4976 5.52482 19.4851 7.0039C20.4726 8.48298 20.9997 10.2215 21 11.9999Z' fill='white'/%3E%3Cpath d='M7.24 13.626V13.158H8.692V13.626H7.24ZM11.0636 15H10.5476V12.006C10.5476 11.89 10.5476 11.792 10.5476 11.712C10.5516 11.632 10.5556 11.558 10.5596 11.49C10.5636 11.418 10.5676 11.344 10.5716 11.268C10.5076 11.332 10.4496 11.386 10.3976 11.43C10.3456 11.474 10.2796 11.53 10.1996 11.598L9.74359 11.97L9.46759 11.616L10.6256 10.716H11.0636V15ZM14.0172 12.372C14.3092 12.372 14.5632 12.422 14.7792 12.522C14.9952 12.622 15.1612 12.766 15.2772 12.954C15.3972 13.138 15.4572 13.364 15.4572 13.632C15.4572 13.928 15.3932 14.184 15.2652 14.4C15.1372 14.612 14.9532 14.776 14.7132 14.892C14.4772 15.004 14.1912 15.06 13.8552 15.06C13.6352 15.06 13.4272 15.04 13.2312 15C13.0392 14.96 12.8772 14.902 12.7452 14.826V14.328C12.8892 14.416 13.0632 14.486 13.2672 14.538C13.4752 14.586 13.6732 14.61 13.8612 14.61C14.0732 14.61 14.2572 14.578 14.4132 14.514C14.5732 14.446 14.6972 14.344 14.7852 14.208C14.8732 14.068 14.9172 13.894 14.9172 13.686C14.9172 13.406 14.8312 13.192 14.6592 13.044C14.4872 12.892 14.2152 12.816 13.8432 12.816C13.7312 12.816 13.6032 12.826 13.4592 12.846C13.3152 12.866 13.1992 12.886 13.1112 12.906L12.8472 12.738L13.0092 10.716H15.1572V11.196H13.4592L13.3572 12.438C13.4252 12.426 13.5172 12.412 13.6332 12.396C13.7492 12.38 13.8772 12.372 14.0172 12.372Z' fill='white'/%3E%3C/svg%3E%0A");
				width: 24px;
				height: 24px;
				background-repeat: no-repeat;
				background-color: transparent;
				border: none;
        cursor: pointer;
			}

      .podcast-player-timeline {
      span{
        font-size: 0.625rem;}
      }

			.podcast-player-title {
				height: 100%;
				gap: 0.75rem;
				max-width: 256px;
				display: flex;
				align-items: center;
        width: 100%;
        span{
        //text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        }
        
        @media (max-width: 768px) {
        &.desktop-hidden{
        display: flex !important;
        }
        
      max-width: unset;
		}

        .podcast-title-text {
          font-size: 0.875rem;
          line-height: 1.25rem;
        }

				img {
					width: 59px;
					height: 100%;
					object-fit: cover;
          aspect-ratio: 1/1;
          @media (max-width: 768px) {
      width: 39px;
		}
				}
			}
		}
	}

  .podcast-player-buttons{
  display: flex;
  gap: .5rem;
  @media (max-width: 768px) {
      flex-direction: row;
      justify-content: center;
			> div{
       width: 100%;
       }
		}
  }

	.button-text {
		@container podcastcontainerdiv (width < 600px) {
			display: none;
		}
	}

	.icon-button {
    cursor: pointer;
		background: transparent;
		font-weight: var(--text-semibold);
		border: none;
		display: flex;
		color: unset;
		padding: 6px;
		text-decoration: underline;
		font-size: 14px;

		@media (max-width: 768px) {
			font-size: 1rem !important;
		}

		align-items: center;
		gap: 6px;

		&:hover {
			text-decoration: none;

		}
	}

	.button-container {
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:not(.button-container--block) {
			button.play-button-variant {
      @media (max-width: 768px) {
      &:before{
						width: 44px;
                    height: 44px;
}
					}
				span {


					display: block;

					@media (max-width: 768px) {
						display: none;
					}
				}
			}
		}

		&.button-container--block {
			.button-div {
				@container podcastcard (width < 550px) {
					width: 100%;
				}
			}

			button.play-button-variant {
				@container podcastcard (width < 550px) {
					span {
						display: none;
					}

				}

				@container podcastcard (width < 550px) {
					span {
						font-size: 1rem;
						margin-left: 0.375rem;
						display: block;
					}

					&:before {
						background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3CforeignObject x='-16' y='-16' width='56' height='56'%3E%3Cdiv xmlns='http://www.w3.org/1999/xhtml' style='backdrop-filter:blur(8px);clip-path:url(%23bgblur_0_8243_4467_clip_path);height:100%25;width:100%25'%3E%3C/div%3E%3C/foreignObject%3E%3Cg data-figma-bg-blur-radius='16'%3E%3Cpath d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill='white'/%3E%3Cpath d='M16.875 11.3712C17.375 11.6507 17.375 12.3493 16.875 12.6288L10.125 16.4016C9.625 16.6811 9 16.3318 9 15.7728L9 8.22716C9 7.66823 9.625 7.31889 10.125 7.59836L16.875 11.3712Z' fill='%23232948'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='bgblur_0_8243_4467_clip_path' transform='translate(16 16)'%3E%3Cpath d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
						filter: none;
						height: 24px;
						width: 24px;
					}

					width: 100%;
					background-color: var(--button-primary-bg);
					padding: 12px 16px 12px 6px;
					align-items: center;
					justify-content: center;
					border-radius: 8px;
					color: white;
					width: 100%;

					span {
						display: block !important;
					}
				}
			}

			justify-content: space-between;

			@container podcastcard (width < 550px) {
				flex-direction: column;
				align-items: flex-start;
				gap: 20px;
				margin-top: 12px;
			}
		}

		.button-container-content {
			--icon-size: 1.5rem;
			display: flex;

		}

		.button-container-content {
			gap: 0.5rem;
		}
	}
}
  `;

  @property({ type: String }) url = "";
  @property({ type: String }) imgsrc = "";
  @property({ type: String }) pdf = "";
  @property({ type: String }) podcasttitle = "";
  @property({ type: Boolean }) blockdesign = false;
  message = {
    eventName: 'postmessage:get:progress'
  };
  message2 = {
    eventName: 'postmessage:get:duration'
  };
  load = {
    eventName: 'postmessage:do:load'
  };
  rewind = {
    eventName: 'postmessage:do:seekback'
  };
  ff = {
    eventName: 'postmessage:do:seekforward'
  };
  play = {
    eventName: 'postmessage:do:play'
  };
  toggle = {
    eventName: 'postmessage:do:toggle'
  };
  pause = {
    eventName: 'postmessage:do:pause'
  };
  getduration = {
    eventName: 'postmessage:get:duration'
  };
  getprogress = {
    eventName: 'postmessage:get:progress'
  };
  seek = (position: number) => {
    return {
      eventName: 'postmessage:do:seek',
      data: { position }
    };  
  };

  iframe: HTMLIFrameElement | null | undefined = null;
  timeline: HTMLInputElement | null | undefined = null;
  @state() private playerIsShowing: boolean = false;
  @state() private isPlaying: boolean = false;
  @state() private progress: string = "";
  @state() private duration: string = "";
  @state() private shareopen: boolean = false;
  @state() private copied: boolean = false;
  @state() private embedcopied: boolean = false;
  
  private playerId = randstr("openmodal-");

  firstUpdated(_changedProperties: PropertyValues): void {
    super.firstUpdated(_changedProperties);
    
    addGlobalStylesToShadowRoot(this.shadowRoot!);
    this.iframe = this.shadowRoot?.querySelector(`#podiframe-${this.playerId}`);
    window.addEventListener(
      'removeplayers',
      event => {
        this.playerIsShowing = false;
        this.isPlaying = false;
      }
    );

    window.addEventListener("beforeunload", this.showConfirmBox.bind(this));

    window.addEventListener(
      'message',
      event => {
        if (event.data.eventName === "postmessage:on:play" && this.playerIsShowing) {
          this.isPlaying = true;
        }
        else if (event.data.eventName === "postmessage:on:pause" && this.playerIsShowing) {
          this.isPlaying = false;
          this.getProgress();
        }
        else if (event.data.eventName === "postmessage:on:pause" && this.playerIsShowing) {
          this.isPlaying = false;
        }
        else if (event.data.eventName === "postmessage:get:duration" && this.playerIsShowing) {
          this.duration = event.data.data.duration;
          
        }
        else if (event.data.eventName === "postmessage:get:progress" && this.playerIsShowing) {
          this.progress = event.data.data.progress;
          this.updateTimeline(event.data.data.progress);
        }
        else if (event.data.eventName === "postmessage:on:seek" && this.playerIsShowing) {
          this.progress = (event.data.data.position / Number.parseFloat(this.duration)) * 100 + "";
          this.updateTimeline(this.progress);
        }
      },
      false
    );
  }

  handleFocus(e: any){
      
  const target = e.target;
  const dialog = e.target.closest('[role="dialog"]');
  const shiftPressed = e.shiftKey;
if (e.key === 'Escape') {
   e.preventDefault(); this.closeshare(); 
  }
  // If TAB key pressed
  else if (e.key === "Tab") {
      // Find the first or the last input element in the dialog parent (depending on whether Shift was pressed).
      // Get the focusable elements (links and buttons)
      let focusElements = dialog?.querySelectorAll("a, button");
      if(focusElements){

      
      let borderElem = shiftPressed
        ? focusElements[0]
        : dialog.querySelector(".shareoptions-morebuttons").offsetParent ? dialog.querySelector(".pdf-button") : dialog.querySelector(".embed-button");
      if (borderElem) {
        // If the current target element is the first or last focusable element in the dialog, prevent the default behaviour.
        if (target === borderElem) {
          e.preventDefault();

          // move focus to the first element when the last one is reached and vice versa
          borderElem === focusElements[0]
            ? (dialog.querySelector(".shareoptions-morebuttons").offsetParent ? dialog.querySelector(".pdf-button") : dialog.querySelector(".embed-button") as HTMLLinkElement).focus()
            : (focusElements[0] as HTMLLinkElement).focus();
        }
      }
    }
  }
}

  showConfirmBox(e : any) {
    if(this.isPlaying){
      e.preventDefault();
    }
  }

  updateTimeline(progress: string) {
    if(this.timeline){
      this.timeline.value = (Number.parseFloat(progress) / 100 * Number.parseFloat(this.duration)).toString();
    this.timeline.style.backgroundImage = '-webkit-gradient(linear, left top, right top, ' +
        'color-stop(' + Number.parseFloat(progress)/100 + ', #fff), ' +
        'color-stop(' + Number.parseFloat(progress)/100 + ', #717680)' +
        ')';
         }
  }

  doPause() {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.pause), '*');
  }
  getDuration() {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.getduration), '*');
  }
  getProgress() {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.getprogress), '*');
  }
  doToggle() {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.toggle), '*');
  }
  doPlay() {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.play), '*');
  }
  doRewind() {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.rewind), '*');
  }
  doFF(){
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.ff), '*');
  }
  doLoad(){
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.load), '*');
  }
  doSeek(position: number) {
    this.iframe?.contentWindow?.postMessage(JSON.stringify(this.seek(position)), '*');
  }
  onPlay() {
    
    if (this.playerIsShowing) {

      this.doToggle();
    }
    else {
      this.dispatchEvent(new CustomEvent("removeplayers", { bubbles: true, composed: true }));
      if(this.isPlaying){
        
      this.timeline?.removeEventListener("change", (e) => {
      var input = e.target as HTMLInputElement;
      this.updateTimeline(input.value);
      
    });
    this.timeline?.removeEventListener("input", (e) => {
      var input = e.target as HTMLInputElement;
      this.updateTimeline(Number.parseFloat(input.value) / (Number.parseFloat(this.duration)) * 100 + "");
      this.progress = (Number.parseFloat(input.value) / (Number.parseFloat(this.duration)) * 100).toString();
    });
      }
      
      this.playerIsShowing = true;
      
      setTimeout(() => {
      this.doLoad();
      this.doPlay();
      
        var intervalId = window.setInterval(() => {
          if(this.isPlaying){
        if(this.duration === "NaN" || this.duration === ""){
          this.getDuration();
        }
        this.getProgress();
          }
}, 1000);
        this.timeline = this.shadowRoot?.querySelector('input[type="range"]') as HTMLInputElement;
    this.timeline?.addEventListener("change", (e) => {
      var input = e.target as HTMLInputElement;
      this.updateTimeline(Number.parseFloat(input.value) / (Number.parseFloat(this.duration)) * 100 + "");
      this.doSeek(Number.parseFloat(input.value));
    });
    this.timeline?.addEventListener("input", (e) => {
      var input = e.target as HTMLInputElement;
      this.updateTimeline(Number.parseFloat(input.value) / (Number.parseFloat(this.duration)) * 100 + "");
      this.progress = (Number.parseFloat(input.value) / (Number.parseFloat(this.duration)) * 100).toString();
    });
      }, 1000)
    }
  }

  handleBackdropClick = () => {
    this.shareopen = false;
  };

  connectedCallback() {
    super.connectedCallback();
  }

  onClick(e: InputEvent) {
    e.preventDefault();
  }

  openshare() {
    this.shareopen = true;
    setTimeout(() => {
    (this.shadowRoot?.querySelector(".shareoptions .copy-button") as HTMLAnchorElement)?.focus();
    }, 100);
  }

  closeshare() {
    this.shareopen = false;
  }

  copyEmbedCode(e: any) {
    const embedCode = `<iframe allow="autoplay" src="https://embed.acast.com/$/${this.url}"></iframe>`;
    navigator.clipboard.writeText(embedCode);
    this.embedcopied = true;
    setTimeout(() => {
      this.embedcopied = false;
    }, 2000);
  }

  copyLink() {
    const embedCode = `https://shows.acast.com/${this.url}`;
    navigator.clipboard.writeText(embedCode);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }

  render() {
    return html`<iframe id="podiframe-${this.playerId}" class="podiframe hidden" allow="autoplay" src="https://embed.acast.com/$/${this.url}"></iframe>
    <div class="button-container ${this.blockdesign ? 'button-container--block' : ''}">
    <div class="button-container-content">
    <a href="https://sphinx.acast.com/${this.url}/media.mp3" target="_blank" class="icon-button"><ehm-icon name="downloadsimple"></ehm-icon>Ladda ner</a>
    ${this.pdf
        ? html`<a href="${this.pdf}" target="_blank" class="icon-button"><ehm-icon name="pdf"></ehm-icon>Transkribering</a>
        ` : html``}
    </div>
    
    <div class="button-div">
    <button class="${!this.isPlaying ? 'play-button-variant' : 'play-button-variant play-button-variant--isplaying'}" title="Lyssna nu" @click="${(this.onPlay)}"><span class="button-text">Lyssna nu</span></button>
    </div>
    </div>
    ${this.playerIsShowing
        ? html`
        <div class="podcast-player">
        <div class="podcast-player-content">
        <div class="podcast-player-title mobile-hidden">
        <img src="${this.imgsrc}" alt="Podcast cover" class="podcast-cover">
        <div class="${this.podcasttitle.length > 30 ? 'marquee long' : this.podcasttitle.length > 20 ? 'marquee medium' : this.podcasttitle.length > 7 ? 'marquee short' : ''}">
        <span class="podcast-title-text">${this.podcasttitle}</span>
        </div>
        </div>
        <div class="podcast-player-actions ${this.progress && this.duration ? '' : 'hidden'}">
        
        <div class="podcast-player-actions__content">
        <div class="podcast-player-title desktop-hidden">
        <img src="${this.imgsrc}" alt="Podcast cover" class="podcast-cover">
        <div class="${this.podcasttitle.length > 30 ? 'marquee long' : this.podcasttitle.length > 20 ? 'marquee medium' : this.podcasttitle.length > 7 ? 'marquee short' : ''}">
        <span class="podcast-title-text">${this.podcasttitle}</span>
        </div>
        </div>
        <div class="podcast-player-buttons">
        <button class="rewind-button" title="Spola bakåt" @click="${(this.doRewind)}"></button>
        <button class="${!this.isPlaying ? 'play-button-variant' : 'play-button-variant play-button-variant--isplaying'}" title="${!this.isPlaying ? 'Spela' : 'Pausa'}" @click="${(this.onPlay)}"></button>
        <button class="ff-button" title="Spola framåt" @click="${(this.doFF)}"></button>
        </div>
        <div class="podcast-player-moreoptions desktop-hidden">
        <button class="icon-button" @click="${(e: any) => { e.preventDefault(); this.openshare(); }}" title="Fler alternativ" target="_blank"><ehm-icon name="dotvertical"></ehm-icon></button>
        </div>
        </div>
        <div class="podcast-player-timeline">
        
        <span>${Math.floor(Number.parseInt((Number.parseInt(this.duration) * Number.parseInt(this.progress) / 100).toFixed(0)) / 60).toFixed(0)}:${((Number.parseInt(this.duration) * Number.parseInt(this.progress) / 100) % 60).toFixed(0).toString().padStart(2, '0')}</span>
        <input type="range" id="range" min="0" max="${(Number.parseInt(this.duration))}" step="0.1" value="${this.duration ? (Number.parseFloat(this.duration) * Number.parseFloat(this.progress) / 100).toFixed(0) : 0}" />
        <span>${Math.floor(Number.parseInt((Number.parseInt(this.duration)).toFixed(0)) / 60).toFixed(0)}:${((Number.parseInt(this.duration)) % 60).toFixed(0).toString().padStart(2, '0')}</span>
        
        </div>
        </div>
        <div class="loadingSpinner ${this.progress && this.duration ? 'hidden' : ''}"><div></div><div></div><div></div><div></div></div></button>
        <div class="podcast-player-buttons mobile-hidden">
        <a href="https://sphinx.acast.com/${this.url}/media.mp3" title="Ladda ner" target="_blank" class="icon-button"><ehm-icon name="downloadsimple"></ehm-icon></a>
        <a href="" @click="${(e: any) => { e.preventDefault(); this.openshare(); }}" title="Dela" target="_blank" class="icon-button"><ehm-icon name="share"></ehm-icon></a>
        ${this.pdf
        ? html`<a href="${this.pdf}" target="_blank" title="Visa transkribering" class="icon-button"><ehm-icon name="pdf"></ehm-icon></a>
        ` : html``}
        </div>
        </div>
        <div role="dialog" class="shareoptions ${this.shareopen ? "" : "hidden"}" @keydown="${this.handleFocus.bind(this)}">
        <div class="shareoptions-header">
        <h3 class="heading-xs">Dela avsnitt</h3>
        <button class="button button--link close-button" @click="${this.closeshare}"><ehm-icon name="close"></ehm-icon></a>
        
        </div>
        <button @click="${(this.copyLink)}" class="button button--tertiary copy-button"><ehm-icon name="copy"></ehm-icon>${this.copied ? "Kopierad!" : "Kopiera länk"}</button>
        <div class="share-buttons">
          <a title="Dela på Facebook" class="facebook-button" href="https://www.facebook.com/sharer/sharer.php?u=https%3A//shows.acast.com/${this.url}" target="_blank"><div></div><span>Facebook</span></a>
          <a title="Dela på LinkedIn" class="linkedin-button" href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A//shows.acast.com/${this.url}" target="_blank"><div></div><span>Linkedin</span></a>
          <a title="Dela på Twitter" class="twitter-button" href="https://twitter.com/intent/tweet?url=https%3A//shows.acast.com/${this.url}&text=Lyssna%20på%20${encodeURIComponent(this.podcasttitle)}%20på%20Acast!" target="_blank"><div></div><span>X</span></a>
          <a title="Dela på Email" class="email-button" href="mailto:?subject=Lyssna på ${encodeURIComponent(this.podcasttitle)} på Acast!&body=Hej!%0D%0A%0D%0AJag ville bara tipsa dig om det här avsnittet av ${this.podcasttitle} som jag tror att du skulle gilla!%0D%0A%0D%0ALyssna på det här: https://shows.acast.com/${this.url}%0D%0A%0D%0AHoppas du gillar det!%0D%0A" target="_blank"><div></div><span>Email</span></a>
          <a title="Kopiera Embed-kod" href="#" class="embed-button" @click="${(e: any) => {e.preventDefault(); this.copyEmbedCode(e)}}" target="_blank"><div></div><span>${this.embedcopied ? "Kopierad!" : "Embed"}</span></a>
          </div>
          <div class="desktop-hidden">
          <div class="shareoptions-morebuttons">
          <a title="Ladda ner" target="_blank" class="download-button" href="https://sphinx.acast.com/${this.url}/media.mp3"}"><div></div></ehm-icon><span>Ladda ner</span></a>
          ${this.pdf
        ? html`<a href="${this.pdf}" target="_blank" title="Visa transkribering" class="pdf-button"><div></div><span>Transkript</span></a>
        ` : html``}
        </div>
          </div>
          <div class="triangle-down"></div>
        </div>
        </div>
        <div class="backdrop ${this.shareopen ? "" : "hidden"}" @click=${this.handleBackdropClick}></div>
        
        <iframe id="main-player-iframe-${this.playerId}" class="main-player-iframe" src="https://embed.acast.com/$/${this.url}?bgColor=040714&amp;accentColor=ffffff" frameBorder="0" allow="autoplay" class="DefaultLayout__Iframe-dGHxkF gXgcXL"></iframe>` : html``}
        `}
}
 